/* eslint-disable @typescript-eslint/naming-convention */
export interface IMemoryRaw {
  id: string;
  content: string;
  created_at: string;
  updated_at: string;
}

export interface IListMemoriesOutputRaw {
  items: IMemoryRaw[];
  has_more: boolean;
}

export interface IMemorySettingsRaw {
  automatic_capture_enabled: boolean;
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface IMemory {
  id: string;
  content: string;
  createdAt: string;
  updatedAt: string;
}

export interface IListMemoriesOutput {
  items: IMemory[];
  hasMore: boolean;
}

export interface IMemoryContentRequest {
  content: string;
}

export interface IMemorySettings {
  automaticCaptureEnabled: boolean;
}

export const toMemory = (raw: IMemoryRaw): IMemory => ({
  id: raw.id,
  content: raw.content,
  createdAt: raw.created_at,
  updatedAt: raw.updated_at
});

export const toListMemoriesOutput = (
  raw: IListMemoriesOutputRaw
): IListMemoriesOutput => ({
  items: raw.items.map(toMemory),
  hasMore: raw.has_more
});

export const toMemorySettings = (raw: IMemorySettingsRaw): IMemorySettings => ({
  automaticCaptureEnabled: raw.automatic_capture_enabled
});

/* eslint-disable @typescript-eslint/naming-convention */
export const toMemorySettingsRaw = (
  settings: IMemorySettings
): IMemorySettingsRaw => ({
  automatic_capture_enabled: settings.automaticCaptureEnabled
});
/* eslint-enable @typescript-eslint/naming-convention */
